import * as actionTypes from '../../types/orders';
import {
  getOrdersExportConfig,
  getOrdersExportListUrl,
  makeOrdersExportUrl,
  getSearchUsersList,
} from '../../../services/endpoints/orders';
import { delay } from '../../../utils/helper';

/**
 * @function
 * @name ordersFetching
 * @description - Лоадер для таблицы
 */
export const ordersFetching = (payload) => (dispatch) => {
  dispatch({ type: actionTypes.FETCHING, payload });
};

/**
 * @function
 * @name ordersPaginationFetching
 * @description - Лоадер для пагинации
 */
export const ordersPaginationFetching = (payload) => (dispatch) => {
  dispatch({ type: actionTypes.FETCHING_PAGINATION, payload });
};

/**
 * @function
 * @name ordersError
 * @description - Вывод ошибки
 */
export const ordersError = (payload) => (dispatch) => dispatch({ type: actionTypes.ERROR, payload });

/**
 * @function
 * @name ordersErrorInit
 * @description - Вывод первого запроса
 */
export const ordersErrorInit = (payload) => (dispatch) => dispatch({ type: actionTypes.ERROR_INIT, payload });

/**
 * @function
 * @name ordersUpdateList
 * @description - Обновление списка orders (updateRows)
 */
export const ordersUpdateList = (orders) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_LIST });
  await delay(1000)
  dispatch({ type: actionTypes.UPDATE_LIST_SUCCESS, payload: { orders } });
};

/**
 * @function
 * @name ordersStatusCounts
 * @param data {array}
 * @description - Обновление status counts
 */
export const ordersStatusCounts = (data) => async (dispatch) => dispatch({ type: actionTypes.GET_STATUSES_COUNTS_SUCCESS, data });

/**
 * @function
 * @name ordersPagination
 * @param data {object}
 * @description - Обновление пагинации
 */
export const ordersPagination = (data) => async (dispatch) => dispatch({ type: actionTypes.GET_PAGINATION_SUCCESS, data });

/**
 * @function
 * @name ordersConfig
 * @param data {object}
 * @description - Обновление конфига
 */
export const ordersConfig = (data) => async (dispatch) => dispatch({ type: actionTypes.GET_CONFIG_SUCCESS, data });

/**
 * @function
 * @name ordersList
 * @param data {object}
 * @description - Обновление листинга
 */
export const ordersList = (data) => async (dispatch) => dispatch({ type: actionTypes.GET_ORDERS_LIST_SUCCESS, data });

/**
 * @function
 * @name getOrdersExportConfigActions
 * @description Конфигурация страницы экспорта
 */
export const getOrdersExportConfigActions = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_EXPORT_CONFIG });

  try {
    const response = await getOrdersExportConfig();
    const { data } = response;

    dispatch({
      type: actionTypes.GET_EXPORT_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.GET_EXPORT_CONFIG_ERROR, error });
  }
};

/**
 * @function
 * @name getExportList
 * @description Список экспортов
 * @param {object} payload
 */
export const getExportListAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_EXPORT_LIST });

  try {
    const response = await getOrdersExportListUrl(payload);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_EXPORT_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: actionTypes.GET_EXPORT_LIST_ERROR, error });
  }
};

/**
 * @function
 * @name onMakeExport
 * @description Создание файла для экспорта
 * @param {object} payload
 */
export const onMakeExportAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.MAKE_EXPORT });

  try {
    await makeOrdersExportUrl(payload);
    dispatch({ type: actionTypes.MAKE_EXPORT_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.MAKE_EXPORT_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function local
 * @name getUsersList
 * @param {string} query - search string for request
 */
export const getUsersList = (query) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_USERS_LIST_SEARCH });

  try {
    const response = await getSearchUsersList(query);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_USERS_LIST_SEARCH_SUCCESS,
      data,
    });

    return data;
  } catch (error) {
    dispatch({ type: actionTypes.GET_USERS_LIST_SEARCH_ERROR, error });
  }
};

/**
 * @function
 * @name deleteHintAction
 * @description - Удаление подсказки
 */
export const deleteHintAction = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_HINT, payload: { id } });
};
